module.exports = __webpack_public_path__ + "img/back6.f5d15205.png";